import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import React from "react";

function DashboardCard({ data, navigate }) {
  return (
    <Card
      sx={{
        minHeight: "100px",
        display: "flex",
        alignItems: "center",
        borderRadius: "12px",
        boxShadow: "0px 3px 10px rgba(0,0,0,0.15)",
        transition: "0.25s",
        background: "#ffffff",
        ":hover": {
          transform: "translateY(-6px)",
          boxShadow: "0px 6px 16px rgba(0,0,0,0.22)",
          cursor: "pointer",
        },
      }}
      onClick={() => data?.link && navigate(data.link)} // ← CLICK HERE
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ width: "100%", px: 2, py: 1 }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography
            fontSize="0.74rem"
            fontWeight="600"
            color="text.secondary"
            sx={{ letterSpacing: 0.4 }}
          >
            {data.title}
          </Typography>

          <Typography
            fontSize="1.4rem"
            fontWeight="700"
            sx={{
              mt: 0.3,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: "#111",
            }}
          >
            {data.number ?? 0}
          </Typography>
        </Box>

        <Box
          sx={{
            borderRadius: "50%",
            padding: 1,
            border: "2px solid #fb6340",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 42,
            height: 42,
          }}
        >
          {data.icon}
        </Box>
      </Stack>
    </Card>
  );
}

export default DashboardCard;
